export default "__VITE_ASSET__Cq$yDtV5__"